<template>
  <div id="app">
    <transition name="show-from-left">
      <popover name="helpreincidencepareto" :width="240">
        <Help :titleChart="titleChart"> 
            <div slot="content">
               <p>{{ $t("142") }} </p>
            </div>     
          </Help>
      </popover>
    </transition>

    <div class="title-charts">{{ $t("143") }}
      <button class="bt-help" v-popover:helpreincidencepareto.right><i class="icon-help ti-help-alt"></i></button>
    </div>

    <highcharts :options="chartOptions" ref='chart'></highcharts>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Vue from 'vue'
import axios from 'axios';
import mixin from '../../../../utils/mixin'

import Popover  from 'vue-js-popover'
Vue.use(Popover)
import Help from 'src/components/Dashboard/Views/components/Help'
import { log } from 'fullcalendar';

export default {
  name: 'charts',
  props: {
    online: {
        type: Boolean
    }
  },
  components: {
    Help
  },
  data () {
    return {
      titleChart: this.$t("143"),
      tableData: [],
      chartOptions: {
        chart: {
          type: 'column',
          backgroundColor: 'rgba(0,0,0,0)',
          style: {
            fontFamily: '\'Unica One\', sans-serif'
          },
          plotBorderColor: '#606063'
        },
        title: {
            text: '',
            style: {
                color: '#E0E0E3',
                textTransform: 'uppercase',
                fontSize: '16px',
                fontWeight: 'bold'
            }
        },
        subtitle: {
            style: {
                color: '#E0E0E3',
                textTransform: 'uppercase'
            }
        },
        xAxis: {
            categories: [],
            crosshair: true,
            gridLineColor: '#707073',
            labels: {
                style: {
                    color: '#E0E0E3'
                },
                overflow: false
            },
            lineColor: '#707073',
            minorGridLineColor: '#505053',
            tickColor: '#707073',
            title: {
                style: {
                    color: '#A0A0A3'
                }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: this.$t("131"),
                style: {
                    color: '#A0A0A3',
                    fontSize: '12px',
                }
            },
            gridLineColor: '#707073',
            labels: {
                style: {
                    color: '#E0E0E3'
                }
            },
            lineColor: '#707073',
            minorGridLineColor: '#505053',
            tickColor: '#707073',
            tickWidth: 1,
        },
        tooltip: {
            backgroundColor: 'rgba(0, 0, 0, 0.85)',
            style: {
                color: '#F0F0F0'
            },
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y} </b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
        },
        plotOptions: {
            series: {
                dataLabels: {
                    enabled: true,
                    color: '#F0F0F3',
                    style: {
                        fontSize: '13px'
                    }
                },
                marker: {
                    lineColor: '#333'
                },
            },
            boxplot: {
                fillColor: '#505053'
            },
            candlestick: {
                lineColor: 'white'
            },
            errorbar: {
                color: 'white'
            },
            column: {
                pointPadding: 0.1,
                borderWidth: 0
            }
        },
        legend: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            itemStyle: {
                color: '#E0E0E3'
            },
            itemHoverStyle: {
                color: '#FFF'
            },
            itemHiddenStyle: {
                color: '#606063'
            },
            title: {
                style: {
                    color: '#C0C0C0',
                    fontSize: '12px'
                }
            }
        },
        labels: {
            style: {
                color: '#707073'
            }
        },
        drilldown: {
            activeAxisLabelStyle: {
                color: '#F0F0F3'
            },
            activeDataLabelStyle: {
                color: '#F0F0F3'
            }
        },
        navigation: {
            buttonOptions: {
                symbolStroke: '#DDDDDD',
                theme: {
                    fill: '#505053'
                }
            }
        },
        // scroll charts
        rangeSelector: {
            buttonTheme: {
                fill: '#505053',
                stroke: '#000000',
                style: {
                    color: '#CCC'
                },
                states: {
                    hover: {
                        fill: '#707073',
                        stroke: '#000000',
                        style: {
                            color: 'white'
                        }
                    },
                    select: {
                        fill: '#000003',
                        stroke: '#000000',
                        style: {
                            color: 'white'
                        }
                    }
                }
            },
            inputBoxBorderColor: '#505053',
            inputStyle: {
                backgroundColor: '#333',
                color: 'silver'
            },
            labelStyle: {
                color: 'silver'
            }
        },
        navigator: {
            handles: {
                backgroundColor: '#666',
                borderColor: '#AAA'
            },
            outlineColor: '#CCC',
            maskFill: 'rgba(255,255,255,0.1)',
            series: {
                color: '#7798BF',
                lineColor: '#A6C7ED'
            },
            xAxis: {
                gridLineColor: '#505053'
            }
        },
        scrollbar: {
            barBackgroundColor: '#808083',
            barBorderColor: '#808083',
            buttonArrowColor: '#CCC',
            buttonBackgroundColor: '#606063',
            buttonBorderColor: '#606063',
            rifleColor: '#FFF',
            trackBackgroundColor: '#404043',
            trackBorderColor: '#404043'
        },
        series: [{
            name: this.$t("143"),
            color: '#F45B5B',
            data: []
        }],
        exporting: { enabled: false },
        credits: {
          enabled: false
        },
        loading: {
            labelStyle: {
                color: 'black',
                textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff',
            },
            style: {
                backgroundColor: 'none',
                opacity: 1,
            }
        },

      },
    }
  },
  mixins: [mixin],
  methods: {
    getData(){
      const API = process.env.ROOT_API;
      const ENDPOINT = 'v1/mysemeq-ambev/get-pareto-reincidencia' 

      let filters = {};
      if(this.online){
        filters = this.filtersOn;
      } else {
        filters = this.filters;
      }

      filters['online'] = 0;
      if(this.online){
        filters['online'] = 1;
        filters['plant'] = filters['planta']
      }

      this.$refs.chart.chart.showLoading();

      let self = this;
      axios({method: 'GET', url: API + ENDPOINT, params: filters, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
      .then(resp => {
        self.tableData = resp.data;
        self.$refs.chart.chart.hideLoading();
      })
      .catch(err => {
        // from mixin
        self.ApiErrorHandler(self, error.response.data.status_code);
        self.$refs.chart.chart.showLoading('Error');
      })
    },
    setChartData () {
        var self = this
        var res = self.tableData

        self.chartOptions.xAxis.categories = []
        self.chartOptions.series[0].data = []
        if(res) {
            res.forEach(function (it) {
              self.chartOptions.xAxis.categories.push(it[0])
              self.chartOptions.series[0].data.push(it[1])
            })
        }
    },
  },
  computed: {
    ...mapGetters(['filters', 'filtersOn']),
  },
  watch: {
    filters: function(newValue){
      this.getData();
    },
    filtersOn: function(newValue){
      this.getData();
    },
    tableData: function(){
      this.setChartData();
    }
  }
}
</script>
<style scoped>
tspan {
    /*fill: #fff;*/
    stroke: none!important;
    stroke-width: 1px;
    stroke-linejoin: round;
    /*color: #fff;*/
   /* font-weight: normal;
    font-size: 14px;*/
}
.highcharts-drilldown-data-label text{
  text-decoration:none !important;
}

.bt-change-chart{
    top: -5px!important;
}

div[data-popover="helpreincidencepareto"] {
    left: 57% !important;
    top: 10% !important;
}

.title-charts {
    margin-top: 30px;
    margin-bottom: -5px;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Charts/ChartReincidenciaPareto.vue